import React from "react";
import LWPostsItem, { PostsList2Props } from "./LWPostsItem";

const PostsItem = (props: PostsList2Props) => {
  return <LWPostsItem {...props} />;
};

export default PostsItem;


